import { DashboardInfoMapper } from "@/data/mapper/dashboard/dashboard-info-mapper";
import { SendNotificationPayload } from "@/data/payload/dashboard/send-notification-payload";
import { safeMapToEntity } from "@/data/repo-Implement/safe-map-to-entity";
import { DashboardSource } from "@/data/source/dashboard-source";
import {
  DashboardData,
  DashboardHomeScope,
} from "@/domain/entity/dashboard/dashboard-entity";
import { DashboardRepository } from "@/domain/repository/dashboard-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class DashboardRepositoryImpl implements DashboardRepository {
  constructor(private readonly dashboardSource: DashboardSource) {}

  async fetchDashboard(
    scope: DashboardHomeScope = "doctor",
  ): Promise<SATResult<DashboardData, SATError>> {
    const result = await this.dashboardSource.fetchDashboard(scope);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return safeMapToEntity(
      result.value,
      DashboardInfoMapper.toEntity,
      "DashboardRepositoryImpl::fetchDashboard",
    );
  }

  async sendNotification(payload: SendNotificationPayload): Promise<SATResult<void, SATError>> {
    const result = await this.dashboardSource.sendNotification(payload);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }
}
